import { NavLink } from 'react-router-dom';

import { useAuth } from '../auth/AuthProvider';

const ITEMS = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/templates', label: 'Templates' },
  { to: '/contracts', label: 'Contracts' },
  { to: '/settings', label: 'Settings' },
];

export function Nav() {
  const { account, user, logout } = useAuth();
  return (
    <nav className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <div className="flex items-center gap-6">
          <span className="font-semibold text-brand">Signatory</span>
          <ul className="flex gap-3 text-sm">
            {ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    isActive
                      ? 'rounded px-2 py-1 font-medium text-brand'
                      : 'rounded px-2 py-1 text-slate-700 hover:bg-slate-100'
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex items-center gap-3 text-sm text-slate-600">
          {account ? (
            <span>
              {account.name ?? account.slug}{' '}
              <span className="text-slate-400">({user?.role})</span>
            </span>
          ) : null}
          <button type="button" className="btn" onClick={logout}>
            Sign out
          </button>
        </div>
      </div>
    </nav>
  );
}
